export default __webpack_public_path__ + "static/media/hoverLog.b6040ebc.svg";